export default {
      id: "icon-file-usage",
      viewBox: "0 0 12 16",
      url: __webpack_public_path__ + "icons.svg#icon-file",
      toString: function () {
        return this.url;
      }
    }